export default __webpack_public_path__ + "static/media/1.3025c7dc.jpg";